export default function isValidCryptoAmount(value: string) {
  return value.match(/^(0|[1-9]\d*)(\.\d*)?$/);
}
